/* unplugin-vue-components disabled */import { render } from "./YImageMagnifier.vue?vue&type=template&id=448b633d"
import script from "./YImageMagnifier.vue?vue&type=script&lang=js"
export * from "./YImageMagnifier.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./YImageMagnifier.vue?vue&type=style&index=0&id=448b633d&lang=postcss&module=css"
cssModules["css"] = style0

import exportComponent from "/root/workspace/njyx-frontend-pc_5kTN/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__